import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import Button from "@mui/material/Button";
import { Modal } from "react-bootstrap";
import ReactiveButton from "reactive-button";
import * as IconName from "react-icons/io";
import blogFetch from "../../axios/config";
import RegisterTypeOccurrence from "./registerTypeOccurrence";
import Context from "../../context/Context";
import language from "../../nls/language.json";

function TypeOccurrence() {
  const [typeoccurences, setypeOccurences] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [state, setState] = useState("idle");
  const [typeOccurrenceId, setypeOccurrenceId] = useState(0);
  const { useRef } = React;
  const ref = useRef();

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getTypeOccurence();
  }, []);

  const getTypeOccurence = async () => {
    try {
      let response = await blogFetch.get("/typeOccurrence");
      let data = response.data;
      setypeOccurences(data);
    } catch (error) {
      console.error(error);
    }
  };

  const saveButton = async () => {
    setState("loading");
    var response = await ref.current.addTypeOcurrence();
    if (response != null) {
      setState("success");
    } else {
      setState("error");
    }
    getTypeOccurence();
  };

  const deleteOcurrence = async (tpO_PK_idTypeOccurrence) => {
    try {
      await blogFetch.delete(`/typeOccurrence/${tpO_PK_idTypeOccurrence}`);
      getTypeOccurence();
    } catch (error) {
      console.error(error);
    }
  };

  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterTypeOccurrence ref={ref}></RegisterTypeOccurrence>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="butto"
            onClick={() => setShowModalAdd(false)}
          >
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.adicionar.btnCancelar}
          </Button>
          <ReactiveButton
            buttonState={state}
            idleText="Salvar"
            loadingText="Loading"
            successText="Ok"
            errorText="Erro"
            onClick={saveButton}
            className="butto"
          />
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterTypeOccurrence
            ref={ref}
            IdTypeOcurrence={typeOccurrenceId}
          ></RegisterTypeOccurrence>
        </Modal.Body>{" "}
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalEdit(false)}>
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.editar.btnCancelar}
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              await ref.current.updateTypeOcurrence();
              setShowModalEdit(false);
              getTypeOccurence();
            }}
          >
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.editar.btnSalvar}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalDelete = () => {
    return (
      <Modal show={showModalDelete} onHide={() => setShowModalDelete(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.deletar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body ref={ref} IdTypeOcurrence={typeOccurrenceId}>
          Deseja realmente inativar o tipo de Ocorrencia?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalDelete(false)}>
          {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.deletar.btnCancelar}
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              deleteOcurrence(typeOccurrenceId);
              setShowModalEdit(false);
            }}
          >
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.deletar.btnSalvar}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.title}
            </h3>
          </div>
          <div>
            <Button
              className="add_button"
              variant="contained"
              onClick={() => {
                modalAdd();
                setShowModal(true);
              }}
            >
              {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.btnAdicionar}
            </Button>
          </div>
        </div>
        <table className="table table-hover">
          <thead className="table-header">
            <tr className="table_row">
              <th>#</th>
              <th>{language[selectedCountry.name].Ocorrencias.tipoOcorrencia.tableHeader.tableHeader}</th>
              <th className="edit">{language[selectedCountry.name].Ocorrencias.tipoOcorrencia.tableHeader.editar}</th>
            </tr>
          </thead>
          <tbody className="table_row">
            {!!typeoccurences &&
              Object.entries(typeoccurences).map((item) => (
                <tr key={item[1].tpO_PK_idTypeOccurrence}>
                  <td>{item[1].tpO_PK_idTypeOccurrence}</td>
                  <td>{item[1].tpO_description}</td>
                  <td className="edit">
                    <IconName.IoIosAdd
                      size="30px"
                      onClick={() => {
                        setypeOccurrenceId(item[1].tpO_PK_idTypeOccurrence);
                        setShowModalEdit(true);
                      }}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterTypeOccurrence ref={ref}></RegisterTypeOccurrence>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {language[selectedCountry.name].Ocorrencias.tipoOcorrencia.modal.adicionar.btnCancelar}
          </Button>
          <ReactiveButton
            buttonState={state}
            idleText="Salvar"
            loadingText="Loading"
            successText="Ok"
            errorText="Erro"
            onClick={saveButton}
            className="butto"
          />
        </Modal.Footer>
      </Modal>
      {modalAdd()}
      {modalDelete()}
      {modalEdit()}
    </>
  );
}

export default TypeOccurrence;
